<template>
	<div class="slider-background">
		<div class="slider-wrapper">
			<div class="white-overlay"></div>
			<slick
				ref="slick"
				:options="slickOptions"
				@afterChange="handleAfterChange"
			>
				<div v-for="item in list" :key="item.id" class="position-item">
					<article class="position-item-wrapper">
						<div class="gradient-bg"></div>
						<div class="dark-overlay"></div>
						<picture class="responsive--image">
							<source :srcset="item.img" type="image/webp" />
							<img :src="item.imgFallback" />
						</picture>
					</article>
				</div>
			</slick>
			<div ref="arrows" class="carousel-arrows">
				<button class="button prev" @click="prev"><-</button>
				<button class="button next" @click="next">-></button>
			</div>
		</div>

		<div class="container">
			<testimony-text-slider
				:list="list"
				@next="next"
				@prev="prev"
				:current-slide="currentSlide"
			></testimony-text-slider>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import TestimonyTextSlider from "./TestimonyTextSlider";
import testimonies from "../../store/modules/testimonies";
import Slick from "vue-slick";

export default {
	name: "testimony-slider",
	components: { TestimonyTextSlider, Slick },
	props: {
		list: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			slider: null,
			currentSlide: 0,
			slickOptions: {
				centerMode: true,
				slidesToShow: 4,
				arrows: false,
				infinite: true,
				variableWidth: true,
				responsive: [
					{
						breakpoint: 1600,
						settings: {
							centerMode: true,
							arrows: false,
							infinite: true,
							centerPadding: "40px",
							slidesToShow: 3,
							variableWidth: true
						}
					},
					{
						breakpoint: 1024,
						settings: {
							centerMode: true,
							infinite: true,
							variableWidth: false,
							arrows: false,
							slidesToShow: 1
						}
					}
				]
			}
		};
	},
	computed: {
		...mapGetters("testimonies", { sliderPosition: "getSliderPosition" })
	},
	watch: {
		sliderPosition() {
			if (this.slider) {
				this.slider.goTo(this.sliderPosition);
			}
		}
	},
	methods: {
		next() {
			this.$refs.slick.next();
		},

		prev() {
			this.$refs.slick.prev();
		},

		reInit() {
			// Helpful if you have to deal with v-for to update dynamic lists
			this.$nextTick(() => {
				this.$refs.slick.reSlick();
			});
		},
		handleAfterChange(event, slick, currentSlide) {
			this.currentSlide = currentSlide;
			//slick.$slides.removeClass("prevdiv").removeClass("nextdiv");

			// find current slide
			/*for (let i = 0; i < slick.$slides.length; i++) {
        let slide = $(slick.$slides[i]);
        console.log(slide);
        if (slide.hasClass("slick-current")) {
          // update DOM siblings
          slide.prev().addClass("prevdiv");
          slide.next().addClass("nextdiv");
          break;
        }
      }*/
		}
	},

	mounted() {}
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../../assets/scss/globals";

.dark-overlay {
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: #000;
	transition: all 300ms ease;
}

.white-overlay {
	position: absolute;
	height: 50%;
	width: 100%;
	background: #fff;
}

.slider-background {
	background: url("/static/img/backgrounds/bohemians-wireframe.jpg");
	background-repeat: no-repeat;
	background-position: center;
	background-position-y: 102%;
}

.slider-wrapper {
	position: relative;
}

.carousel-arrows {
	&:hover {
		// background-color: $ice;
	}

	@media (min-width: $tablet) {
		display: none;
	}

	.button {
		padding: 0.65em;
		background-color: black;
		color: white;
		position: absolute;
		top: 50%;
		margin-top: -20px;
	}

	@media (min-width: $compact) {
		.button {
			padding: 1.25em;
		}
	}

	.next {
		right: 25px;
	}

	.prev {
		left: 25px;
	}
}

.position-item-wrapper {
	position: relative;
}

.position-item {
	position: relative;
	padding: 40px;

	img {
		width: 100%;

		@media (min-width: $tablet) {
			max-width: 505px;
			object-fit: cover;
		}
	}

	.dark-overlay {
		opacity: 0.4;
	}

	transition: all 400ms ease-out;
	transition-delay: 0.2s;
}

.slick-current {
	.position-item {
		.dark-overlay {
			opacity: 0;
		}

		@media (min-width: $tablet) {
			transform: scale(1.18);
		}
	}
}

.gradient-bg {
	background-image: linear-gradient(to top, #6e3acb 0%, #00b5f2 100%);
	height: 100%;
	width: 100%;
	position: absolute;
	z-index: -2;
	bottom: -10px;
	right: -10px;
	opacity: 0.9;
}

.responsive--img {
	width: 100%;
	max-width: 100%;
	height: auto;
}

.container {
	padding: 30px;
	@media (max-width: $compact) {
		padding: 15px;
		padding-top: 0;
	}
	@media (min-width: $tablet) {
		margin-top: 118px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/sliders/TestimonySlider.vue